import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_flSchoolAuthorization = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_flSchoolAuthorization' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    I hereby authorize Northwest Behavioral Health Services (NWBHS) staff to enter
                    <input type='text' id='txt_1' name='txt_1' className='add-only w-350 custom-add-only' /> School to provide services in
                    directly in the school setting. In addition, I also
                    authorize Northwest Behavioral Health to release and/or obtain confidential information from child's/ward's school
                    including information from school guidance counselors, school psychologist, school social workers, teachers,
                    administrators, and other school staff who work directly with my child/ward. This information can include the
                    following:
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cb_1' name='cb_1' className='add-only' value='1' />Biopsychosocial Evaluation <br />
                    <input type='checkbox' id='cb_2' name='cb_2' className='add-only' value='1' />Demographic Information <br />
                    <input type='checkbox' id='cb_3' name='cb_3' className='add-only' value='1' />Diagnosis <br />
                    <input type='checkbox' id='cb_4' name='cb_4' className='add-only' value='1' />Currently Prescribed Medications <br />
                    <input type='checkbox' id='cb_5' name='cb_5' className='add-only' value='1' />Treatment Plan/Review <br />
                    <input type='checkbox' id='cb_6' name='cb_6' className='add-only' value='1' />Presence and Participation in Treatment <br />
                    <input type='checkbox' id='cb_7' name='cb_7' className='add-only' value='1' />Progress in Treatment <br />
                    <input type='checkbox' id='cb_8' name='cb_8' className='add-only' value='1' />Continuing Care Plan <br />
                    <input type='checkbox' id='cb_9' name='cb_9' className='add-only' value='1' />Discharge/Transfer Summary <br />
                    <input type='checkbox' id='cb_10' name='cb_10' className='add-only' value='1' />Educational Information <br />
                    <input type='checkbox' id='cb_11' name='cb_11' className='add-only' value='1' />Psychological Evaluation/Psychiatric Evaluation <br />
                    <input type='checkbox' id='cb_12' name='cb_12' className='add-only' value='1' />Toxicological Reports/Drug Screens <br />
                    <input type='checkbox' id='cb_13' name='cb_13' className='add-only' value='1' />Other: &nbsp;
                    <input type='text' id='txt_2' name='txt_2' className='add-only w-350 custom-add-only' />
                </p>


                <p className='w-750'>
                    I understand and acknowledge that information obtained from or provided to my child's/ward's school will be done
                    so within the confines of the Health Insurance Portability and Accountability Act (HIPAA),
                    Code of Federal Regulations (C.F.R.) Parts 160 and 164 and the Standards for Privacy of Individually Identifiable
                    Health Information (Privacy Standards) and will be kept in the strictest of confidence as prescribed by law. I also
                    acknowledged that this consent will remain in effect for a period of one year, but that I have the right to revoke
                    this consent for my child/ward at any time.
                </p>
                <p className='w-750'>
                    I hereby provide my consent for release of my child's/ward's PHI to the school named above voluntarily as indicated by my signature below.
                </p>

            </div>
        </form>

    )
}

